import { Text } from '@doordash/design-language'
import * as React from 'react'

// TODO: this doesn't need to be abstraced, but will keep abstracted
// during refactor to avoid confusion. After all components that use
// this are migrated, will just use Title
const PageHeader: React.SFC = props => (
  <Text styles={Text.Styles.Bold32}>{props.children}</Text>
)

export default PageHeader
